import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import './index.less';
import SideBarTool from "@/commons/components/side-bar-tool";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { addEscapeRoute, deleteEscapeRoute, getEscapeRoutes, updateEscapeRoute } from '@/api/building/escape-route';
import { ReactComponent as LinkSvg } from '@/commons/icons/panel-icon/link.svg';
import { EscapeRoute, StoreyEscapeRoute } from '@/commons/interface/building/escape-route';
import { Input, Modal, message } from 'antd';
import { ReactComponent as ConfimSvg } from '@/commons/icons/marshalling/confim.svg';
import { ReactComponent as EditSvg } from '@/commons/icons/marshalling/edit.svg';
import classNames from 'classnames';
import { graphicStore } from '@/commons/store/graphic-store';
import { AddPrimitivesCommand, ModelBase } from "pytha";
import { BimModelBase, GroupType } from 'tnbimbase';
import TnModal from '@/commons/widget/base-modal';
import SelectModal from '@/commons/widget/select-modal';
import { createPrimitiveMulti } from '@/api/geometry/primitive';
import { EscapeRouteType } from '@/commons/enums/escape-route';

const tempFireControlEscapeRouteData: { value: string, uuid: string }[] = [
    { value: "controlEscapeRoute_DE", uuid: "a1230a25-3805-4298-a94e-75b1c235a240" },
    { value: "controlEscapeRoute_ny", uuid: "c12371ae-250e-4a98-9c72-e8024d214731" },
    { value: "controlEscapeRoute_eu", uuid: "7123891c-c5e9-4798-b1bc-b3058609bb48" },
    { value: "controlEscapeRoute_Gn", uuid: "0123786d-6346-4198-a883-780620cc02b8" },
    { value: "controlEscapeRoute_as", uuid: "e123221f-bdc4-4a98-a9c8-afbc920091c9" },
    { value: "controlEscapeRoute_pz", uuid: "9123e035-3508-4598-bf5d-e86694c754a5" },
    { value: "controlEscapeRoute_hn", uuid: "c1234e1c-9986-4698-9c2c-a646d18834ag" },
    { value: "controlEscapeRoute_NI", uuid: "01237522-62e1-4d98-81c6-0461b66905cb" },
    { value: "controlEscapeRoute_xA", uuid: "31237a90-f9bc-4298-a325-563f03ed6e4b" },
    { value: "controlEscapeRoute_Sg", uuid: "2123da6f-5582-4a98-b93d-5bc5b70f8df3" },
]

export default function EscapeRoutePanel() {

    const { projectUuid, modelUuid } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [displayEscapeRoutes, setDisplayEscapeRoutes] = useState<EscapeRoute[]>([]);
    const [activeEscapeRoute, setActiveEscapeRoute] = useState<EscapeRoute>();
    const [editEscapeRouteUuid, setEditEscapeRouteUuid] = useState<string>('');
    const [editEscapeRouteName, setEditEscapeRouteName] = useState<string>('');
    const [showAddEscapeRoute, setShowAddEscapeRoute] = useState<boolean>(false);
    const [showBtnGroup, setShowBtnGroup] = useState<boolean>(false);

    const [modalOpen, setModalOpen] = useState<boolean>(false)

    useEffect(() => {
        getEscapeRoutes(projectUuid, modelUuid, EscapeRouteType.ESCAPE_ROUTE).then(res => {
            if (res.status === 200) {
                let displayEscapeRoutes: StoreyEscapeRoute[] = res.data || [];
                if (displayEscapeRoutes?.length > 0) {
                    let escapeRoutes = displayEscapeRoutes[0].escapeRoutes || [];
                    setDisplayEscapeRoutes(escapeRoutes);
                } else {
                    setDisplayEscapeRoutes([]);
                }
            }
        })
    }, [projectUuid,modelUuid])

    const onConfirmLink = (e: string) => {
        if (!(e?.length > 0)) return
        let entities: ModelBase[] = activeEscapeRoute?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        let saveJsonList = []
        for (let i = 0; i < entities.length; i++) {
            // createPrimitive
            let data = { ...entities[i]?.extraData || {}, fireControlEscapeRouteUuid: e }
            entities[i].extraData = data
            saveJsonList.push(entities[i].toJson())
        }
        createPrimitiveMulti(saveJsonList, { modelUuid: modelUuid, projectUuid: projectUuid }).catch((e) => {
            message.error("更新失败！")
        })
    }

    const onClickLink = () => {
        setModalOpen(true)
    }


    const onDeleteClick = () => {
        if (!activeEscapeRoute) {
            message.warning("没有选中消防通道");
            return;
        }
        TnModal().deleteModal({
            closable: false,
            onOk() {
                deleteEscapeRoute(projectUuid, activeEscapeRoute.uuid).then(res => {
                    message.success("删除成功");
                    // 1 去除属性
                    let idx = displayEscapeRoutes.findIndex(item => item.uuid === activeEscapeRoute.uuid);
                    let escapeRoute = displayEscapeRoutes[idx];
                    let priUuids = escapeRoute?.primitiveUuids || [];
                    if (priUuids?.length > 0) {
                        let newEntities = [];
                        for (let uuid of priUuids) {
                            let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                            if (!(entity as BimModelBase).group[GroupType.ESCAPE_ROUTE]) {
                                continue;
                            }
                            let groupUuids = (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE];
                            groupUuids = groupUuids?.filter(item => item !== activeEscapeRoute.uuid) || [];
                            (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE] = groupUuids;
                            newEntities.push(entity);
                        }
                        new AddPrimitivesCommand(newEntities).execute();
                    }
                    // 2 修改列表
                    displayEscapeRoutes.splice(idx, 1);
                    setDisplayEscapeRoutes([...displayEscapeRoutes]);

                }).finally(() => {
                    setActiveEscapeRoute(null);
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
        })
    }

    const onEscapeRouteClick = (sub) => {
        setActiveEscapeRoute(sub);
        let entities: ModelBase[] = sub?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
        if (entities?.length > 0) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.forceEntitiesSelected.dispatch(entities);
        }
    }

    const onAddBtnClick = () => {
        setEditEscapeRouteName("");
        setEditEscapeRouteUuid("");
        setShowAddEscapeRoute(true);
    }

    const onAddSave = () => {
        if (!projectUuid || !modelUuid) return;
        if (loading) return;
        if (!editEscapeRouteName) {
            setEditEscapeRouteName("");
            setShowAddEscapeRoute(false);
            return;
        }
        setLoading(true);
        let data: EscapeRoute = {
            projectUuid: projectUuid,
            modelUuid: modelUuid,
            name: editEscapeRouteName,
            type: EscapeRouteType.ESCAPE_ROUTE,
        }
        addEscapeRoute(projectUuid, modelUuid, data).then(res => {
            if (res.status === 200) {
                let uuid = res.data;
                message.success("添加成功");
                data.uuid = uuid;
                displayEscapeRoutes.push(data);
                setDisplayEscapeRoutes([...displayEscapeRoutes]);
            }
        }).catch(() => {
            message.error("添加失败");
        }).finally(() => {
            setLoading(false);
            setShowAddEscapeRoute(false);
            setEditEscapeRouteName("");
            setEditEscapeRouteUuid("");
        })
    }

    const onEscapeRouteEditClick = (escapeRoute: EscapeRoute) => {
        setEditEscapeRouteUuid(escapeRoute.uuid);
        setEditEscapeRouteName(escapeRoute.name);
        setActiveEscapeRoute(escapeRoute);
        setShowBtnGroup(true);
        let entities: ModelBase[] = escapeRoute?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        if (entities?.length > 0) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.forceEntitiesSelected.dispatch(entities);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onCursorChange.dispatch(3);
        }
    }

    const onSave = () => {
        // 1.获取当前选中的图元
        let selectedList = graphicStore.extraContext.getCurrentViewEditor().selectControl.getSelectedEntityList();
        let newPriUuids: string[] = selectedList?.map(item => item.uuid) || [];
        let activeEscapeRouteUuids = new Set(activeEscapeRoute?.primitiveUuids || []);
        let newPriUuidsSet = new Set(newPriUuids);
        let addedUuids = newPriUuids.filter(uuid => !activeEscapeRouteUuids.has(uuid));
        let removedUuids = [...activeEscapeRouteUuids].filter(uuid => !newPriUuidsSet.has(uuid));

        // 2.传递参数回去
        let data: EscapeRoute = {
            ...activeEscapeRoute,
            name: editEscapeRouteName,
        }
        // 3.修改api 同步修改图元属性
        updateEscapeRoute(activeEscapeRoute.uuid, data).then(res => {
            if (res.status === 200) {
                // 1 修改图元属性（旧的需要删除属性，新的需要新增属性）
                let newEntities = [];
                for (let uuid of addedUuids) {
                    let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                    if (!(entity as BimModelBase).group[GroupType.ESCAPE_ROUTE]) {
                        (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE] = [];
                    }
                    let groupUuids = (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE] || [];
                    groupUuids.push(activeEscapeRoute.uuid);
                    (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE] = groupUuids;
                    newEntities.push(entity);
                }

                for (let uuid of removedUuids) {
                    let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                    if (!(entity as BimModelBase).group[GroupType.ESCAPE_ROUTE]) {
                        continue;
                    }
                    let groupUuids = (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE];
                    groupUuids = groupUuids?.filter(item => item !== activeEscapeRoute.uuid) || [];
                    (entity as BimModelBase).group[GroupType.ESCAPE_ROUTE] = groupUuids;
                    newEntities.push(entity);
                }
                new AddPrimitivesCommand(newEntities).execute();
                // 2 修改列表
                let idx = displayEscapeRoutes?.findIndex(item => item.uuid === activeEscapeRoute.uuid);
                displayEscapeRoutes[idx].primitiveUuids = newPriUuids;
                displayEscapeRoutes[idx].name = editEscapeRouteName;
                setDisplayEscapeRoutes([...displayEscapeRoutes]);
                message.success("编辑成功");

            }
        }).catch(err => {
            console.log('err', err)
            message.error("编辑失败");
        }).finally(() => {
            onCancel();
        })
    }

    const onCancel = () => {
        setEditEscapeRouteName("");
        setEditEscapeRouteUuid("");
        setShowBtnGroup(false);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onCursorChange.dispatch(1);
    }

    return (
        <div className='fire-control-escapeRoute-container'>
            <SideBarTool
                activeBtnList={[SideBarBtnType.DELETE, SideBarBtnType.ADD]}
                onDeleteBtnClick={onDeleteClick}
                onAddBtnClick={onAddBtnClick}
            />
            <div className="escapeRoute-side-title">消防通道</div>
            <div className='escapeRoute-content-area'>
                <div className='escapeRoute-content'>
                    {showAddEscapeRoute && (
                        <div className={classNames({
                            'escapeRoute-row': true,
                            'escapeRoute-row-active': true,
                        })}>
                            <div className='text-area'>
                                <Input
                                    value={editEscapeRouteName}
                                    onChange={(e) => setEditEscapeRouteName(e.target.value)}
                                    onPressEnter={onAddSave}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') {
                                            setShowAddEscapeRoute(false);
                                            setEditEscapeRouteName("");
                                            setEditEscapeRouteUuid("");
                                        }
                                    }}
                                    placeholder='单击输入消防通道名称'
                                    autoFocus
                                />
                            </div>
                            <div className='icon-area' onClick={onAddSave}><ConfimSvg /></div>
                        </div>
                    )}
                    {displayEscapeRoutes?.map((item, key) => (
                        <div
                            key={key}
                            className={classNames({
                                'escapeRoute-row': true,
                                'escapeRoute-row-active': activeEscapeRoute?.uuid === item.uuid,
                            })}
                            onClick={() => onEscapeRouteClick(item)}
                        >
                            <div className='text-area'>
                                {editEscapeRouteUuid !== item.uuid && `${item?.name}`}
                                {editEscapeRouteUuid === item.uuid && <Input
                                    value={editEscapeRouteName}
                                    onChange={(e) => setEditEscapeRouteName(e.target.value)}
                                    onPressEnter={onSave}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') {
                                            setShowAddEscapeRoute(false);
                                            setEditEscapeRouteName("");
                                            setEditEscapeRouteUuid("");
                                            setShowBtnGroup(false);
                                            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
                                        }
                                    }}
                                    placeholder='单击输入消防通道名称'
                                    autoFocus
                                />}
                            </div>
                            {editEscapeRouteUuid !== item?.uuid && (
                                <div className='icon-list'>
                                    <EditSvg className='icon-area'
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onEscapeRouteEditClick(item);
                                        }} />
                                    <LinkSvg className='icon-area' onClick={() => { onClickLink() }} />
                                </div>
                            )}
                            {editEscapeRouteUuid === item?.uuid && <ConfimSvg onClick={onSave} />}
                        </div>
                    ))}
                </div>
            </div>
            {showBtnGroup && <div className='escapeRoute-btn-group'>
                <div className="btn save" onClick={onSave}>确定</div>
                <div className="btn cancel" onClick={onCancel}>取消</div>
            </div>}
            <SelectModal onConfirmClick={(e) => { onConfirmLink(e) }} data={tempFireControlEscapeRouteData} isOpen={modalOpen} setIsOpen={setModalOpen} />

        </div>
    )
}